/**
 * Cuenta bancaria
 *
 */
import React from 'react'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { Form, Select, Modal, Button, Row, Col, Input, Divider } from 'antd'
import { KernelAdjuntosTable } from '../../Sub/Components/KernelAdjuntos'

function buildFormObject(values = {}) {
  return {
    iId: values.iId,
    iId_Moneda: values.iId_Moneda || null,
    iId_Banco: values.iId_Banco || null,
    sNombreCuenta: values.sNombreCuenta || null,
    sClaveBan: values.sClaveBan || null,
    sCuenta: values.sCuenta || null,
    sSWIFT: values.sSWIFT || null,
    sABA: values.sABA || null,
    sRTN: values.sRTN || null,
    iDisponible: values.iDisponible === null || values.iDisponible === undefined ? true : values.iDisponible,
  }
}

class CuentaBancariaForm extends React.Component {
  /**
   * handleSubmit
   *
   */
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit && this.props.onSubmit(values)
      }
    })
  }

  componentDidMount() {
    this.mounted = true
    if (this.props.defaultValues){
      const defaultValues = this.props.defaultValues
      const values = {
        ...buildFormObject(defaultValues),
        iId_Moneda: defaultValues.iId_Moneda ? defaultValues.iId_Moneda.toString() : null,
        iId_Banco: defaultValues.iId_Banco ? defaultValues.iId_Banco.toString() : null,
        iDisponible: defaultValues.iDisponible ? '1' : '0',
      }
      this.props.form.setFieldsValue(values)
    }
  }

  componentWillReceiveProps(props) {
    if (this.props.defaultValues !== props.defaultValues && this.mounted) {
      const values = {
        ...buildFormObject(props.defaultValues),
        iId_Moneda: props.defaultValues.iId_Moneda ? props.defaultValues.iId_Moneda.toString() : null,
        iId_Banco: props.defaultValues.iId_Banco ? props.defaultValues.iId_Banco.toString() : null,
        iDisponible: props.defaultValues.iDisponible ? '1' : '0',
      }
      this.props.form.setFieldsValue(values)
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  /**
   * render
   *
   */
  render() {
    const { getFieldDecorator } = this.props.form
    const monedaSel = +this.props.form.getFieldValue('iId_Moneda')

    const moneda = !monedaSel ?
      undefined :
      this.props.monedas.find(m => +m.iId === monedaSel)

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={16}>
          <Col span={16}>
            <Form.Item label='NOMBRE'>
              {getFieldDecorator('sNombreCuenta', { rules: [{ required: true, message: 'Se requiere un nombre' }] })(
                <Input placeholder='Nombre o alias de la cuenta' />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='¿ACTIVA?'>
              {getFieldDecorator('iDisponible')(
                <Select
                  children={[
                    <Select.Option key='1'>SI</Select.Option>,
                    <Select.Option key='0'>NO</Select.Option>
                  ]}
                />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='BANCO'>
              {getFieldDecorator('iId_Banco', { rules: [{ required: true, message: 'Se requiere el banco' }] })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder='Elija un banco'
                  children={this.props.bancos.map(banco =>
                    <Select.Option key={banco.iId.toString()}>{banco.sNombre}</Select.Option>
                  )}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label='MONEDA'>
              {getFieldDecorator('iId_Moneda', { rules: [{ required: true, message: 'Se requiere la moneda' }] })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder='Elija una moneda'
                  children={this.props.monedas.map(moneda =>
                    <Select.Option key={moneda.iId.toString()}>{moneda.sCodigo}</Select.Option>
                  )}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label='# CUENTA'>
              {getFieldDecorator('sCuenta', { rules: [{ required: true, message: 'NO. CUENTA' }] })(
                <Input placeholder='NO. CUENTA' />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label='CLABE'>
              {getFieldDecorator('sClaveBan', { rules: [{ required: moneda && moneda.iLocal, message: 'CLABE' }] })(
                <Input placeholder='CLABE' />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label='SWIFT'>
              {getFieldDecorator('sSWIFT')(
                <Input placeholder='SWIFT' />
              )}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label='ABA'>
              {getFieldDecorator('sABA')(
                <Input placeholder='ABA' />
              )}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label='RTN'>
              {getFieldDecorator('sRTN')(
                <Input placeholder='RTN' />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Form.Item>
            <Button htmlType="submit" type='primary' loading={this.props.loading}>GUARDAR</Button>
          </Form.Item>
        </Row>
      </Form>
    )
  }
}

const WrappedCuentaBancariaForm = Form.create({ name: 'cuentaBancaria' })(CuentaBancariaForm)

class CuentaBancariaModal extends React.Component {
  /**
   * constructor
   *
   */
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      visible: false,
      data: buildFormObject(),
      monedas: [],
      bancos: [],
    }

    this.formRef = React.createRef()
  }

  /**
   * load
   *
   */
  load = (cuentaId) => {
    this.setState({
      loading: false,
      data: buildFormObject({ iId: cuentaId }),
    })

    Api.query.list({
      cuenta: {
        __returnType: 'one',
        model: 'ComProveedorBanco',
        attributes: Object.keys(buildFormObject()),
        where: {
          iId: cuentaId,
        }
      },
      monedas: {
        model: 'AlmMoneda',
        attributes: ['iId', 'sCodigo', 'iLocal'],
        where: {
          iActivo: true,
        }
      },
      bancos: {
        model: 'ConBancoSAT',
        attributes: ['iId', ['sSATNombre', 'sNombre']],
        where: {
          iActivo: true,
        }
      }
    })
    .then(response => {
      this.setState({
        visible: true,
        data: response.data.cuenta || buildFormObject({ iId: -2 }),
        monedas: response.data.monedas || [],
        bancos: response.data.bancos || [],
      })
    })
    .catch(error => {
      this.setState({ loading: false })
      Exception.load(error).show()
    })
  }

  /**
   * onSave
   *
   */
  onSave = (record) => {
    if (this.state.loading) {
      return
    }

    if (!record.errors) {
      this.setState({ loading: true })

      const onError = error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      }

      const data = {
        ...record,
        iId_Prov: Api.getProviderId(),
      }

      if (this.state.data.iId === -2) {
        Api.post('/com/proveedores/cuentas', data)
          .then(() => {
            this.setState({ visible: false, loading: false })
            this.props.onCreate && this.props.onCreate()
            this.props.onSaved && this.props.onSaved()
          })
          .catch(onError)
      } else {
        Api.put(`/com/proveedores/cuentas/${this.state.data.iId}`, data)
          .then(() => {
            this.setState({ visible: false, loading: false })
            this.props.onSaved && this.props.onSaved()
          })
          .catch(onError)
      }
    }
  }

  /**
   * Render
   *
   */
  render() {
    const cuentaNueva = this.state.data.iId === -2

    const form = (
      <WrappedCuentaBancariaForm
        bancos={this.state.bancos}
        monedas={this.state.monedas}
        onSubmit={this.onSave}
        defaultValues={this.state.data}
        loading={this.state.loading}
      />
    )

    return (
      <Modal
        title={cuentaNueva ? 'Nueva cuenta' : 'Cuenta bancaria'}
        visible={this.state.visible}
        style={{ width: '50%', maxWidth: 520 }}
        onCancel={() => this.setState({ visible: false })}
        footer={false}
        children={cuentaNueva ? form : (
          <div>
            {form}

            <Divider />

            <h3>Adjuntos</h3>
            <KernelAdjuntosTable
              model='ComProveedorBanco'
              docId={this.state.data.iId}
              statusField='iDisponible'
              allowStatus={true}
            />
          </div>
        )}
      />
    )
  }
}

export default CuentaBancariaModal
